import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import { getListAPI as getProduct2skill2exp2rateList } from 'components/product2skill2exp2rate/Product2skill2exp2rateAPI';
import { getListAPI as getSkillList} from 'components/skill/SkillAPI';
import { setProduct2skill2exp2rateList, setProduct2skill2exp2rateDashboardProduct2skill2exp2rateList,setWorkerList, setSkillList } from 'store/slice/ManufSlice';
import Product2skill2exp2rateDashboard from '../Product2skill2exp2rateDashboard';
import { getListAPI as getWorkerList } from 'components/worker/WorkerAPI';


export default function Product2skill2exp2ratePageImpl() {
    const dispatch = useDispatch();
    const { product2skill2exp2rateList} = useSelector((state)=>state.manufslice);
    
    const getProduct2skill2exp2rateListSuccess = (list) =>{dispatch(setProduct2skill2exp2rateList(list));}
    const getWorkerListSuccess = (list) =>{dispatch(setWorkerList(list));}
    const getSkillListSuccess = (list) =>{dispatch(setSkillList(list));}
    useEffect(() => {
         getWorkerList(()=>{}, getWorkerListSuccess);
         getSkillList(()=>{}, getSkillListSuccess);
        getProduct2skill2exp2rateList(()=>{}, getProduct2skill2exp2rateListSuccess);
    },[]);
    useEffect(()=>{
        dispatch(setProduct2skill2exp2rateDashboardProduct2skill2exp2rateList( product2skill2exp2rateList));
    },[ product2skill2exp2rateList])

    return (
        < Product2skill2exp2rateDashboard />
    )

}